import script from "./Title.vue?vue&type=script&setup=true&lang=ts"
export * from "./Title.vue?vue&type=script&setup=true&lang=ts"

import "./Title.vue?vue&type=style&index=0&id=32fb50b9&scoped=true&lang=scss"

import exportComponent from "/var/www/fgc-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32fb50b9"]])

export default __exports__